import { TranslateService } from '@ngx-translate/core';
import { ICreator } from '@pages/creators/creators.interface';

export const ALL_CREATORS_ID = 'all-creators';

export const ALL_CREATORS_OPTION = (translate: TranslateService): ICreator =>
  ({
    channels: [],
    icon: 'icons/world.svg',
    id: ALL_CREATORS_ID,
    name: translate.instant('pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.globalAllCreators'),
  }) as const;
